import { useEffect } from "react";

const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/b821e919-43a6-4bea-ad55-02da5d8ff7c3/images/a8c6c8d2fbbe5d90dc92f8f2bb4e1949c48de6fdf7bc2fa8dc2962c12e681c8d.jpeg";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}
function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

export function Seo({ title, description, path = "/", image = OG_IMAGE, noindex = false }) {
  useEffect(() => {
    const url = `https://helserebellen.no${path}`;
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setCanonical(url);
    setMeta("property", "og:title", title || "");
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title || "");
    setMeta("name", "twitter:description", description || "");
    setMeta("name", "twitter:image", image);
  }, [title, description, path, image, noindex]);
  return null;
}
